var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("table", { staticClass: "table" }, [
    _c("thead", [
      _c("tr", [
        _c("th", [_vm._v(_vm._s(_vm.$t("cellCostKind")))]),
        _vm._v(" "),
        _c("th", [_vm._v(_vm._s(_vm.$t("cellCostSumCost")))]),
        _vm._v(" "),
        _c("th", [_vm._v(_vm._s(_vm.$t("cellCostSumTime")))]),
        _vm._v(" "),
        _c("th", [_vm._v(_vm._s(_vm.$t("cellCostLastStart")))]),
        _vm._v(" "),
        _c("th", [_vm._v(_vm._s(_vm.$t("cellCostLastEnd")))]),
        _vm._v(" "),
        _c("th", [_vm._v(_vm._s(_vm.$t("cellCostLastCostCenter")))]),
        _vm._v(" "),
        _c("th", [_vm._v(_vm._s(_vm.$t("cellCostLastCostUnit")))])
      ])
    ]),
    _vm._v(" "),
    _c("tbody", [
      _vm.plannedCosts
        ? _c(
            "tr",
            [
              _c("td", [_vm._v(_vm._s(_vm.$t("cellCostPlanned")))]),
              _vm._v(" "),
              _c("td", { staticStyle: { "text-align": "right" } }, [
                _vm._v(_vm._s(_vm.formatNumber(_vm.plannedCosts.totalAmount)))
              ]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(_vm.plannedCosts.totalTime))]),
              _vm._v(" "),
              _vm.plannedCosts.lastCost
                ? [
                    _c("td", [
                      _vm._v(
                        _vm._s(
                          _vm.formatDateTime(
                            _vm.plannedCosts.lastCost.startTime
                          )
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        _vm._s(
                          _vm.formatDateTime(_vm.plannedCosts.lastCost.endTime)
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(_vm._s(_vm.plannedCosts.lastCost.costCenter))
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(_vm._s(_vm.plannedCosts.lastCost.costUnit))
                    ])
                  ]
                : [
                    _c("td"),
                    _vm._v(" "),
                    _c("td"),
                    _vm._v(" "),
                    _c("td"),
                    _vm._v(" "),
                    _c("td")
                  ]
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.unplannedCosts
        ? _c(
            "tr",
            [
              _c("td", [_vm._v(_vm._s(_vm.$t("cellCostUnplanned")))]),
              _vm._v(" "),
              _c("td", { staticStyle: { "text-align": "right" } }, [
                _vm._v(_vm._s(_vm.formatNumber(_vm.unplannedCosts.totalAmount)))
              ]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(_vm.unplannedCosts.totalTime))]),
              _vm._v(" "),
              _vm.unplannedCosts.lastCost
                ? [
                    _c("td", [
                      _vm._v(
                        _vm._s(
                          _vm.formatDateTime(
                            _vm.unplannedCosts.lastCost.startTime
                          )
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        _vm._s(
                          _vm.formatDateTime(
                            _vm.unplannedCosts.lastCost.endTime
                          )
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(_vm._s(_vm.unplannedCosts.lastCost.costCenter))
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(_vm._s(_vm.unplannedCosts.lastCost.costUnit))
                    ])
                  ]
                : [
                    _c("td"),
                    _vm._v(" "),
                    _c("td"),
                    _vm._v(" "),
                    _c("td"),
                    _vm._v(" "),
                    _c("td")
                  ]
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.correctionCosts
        ? _c(
            "tr",
            [
              _c("td", [_vm._v(_vm._s(_vm.$t("cellCostCorrection")))]),
              _vm._v(" "),
              _c("td", { staticStyle: { "text-align": "right" } }, [
                _vm._v(
                  _vm._s(_vm.formatNumber(_vm.correctionCosts.totalAmount))
                )
              ]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(_vm.correctionCosts.totalTime))]),
              _vm._v(" "),
              _vm.correctionCosts.lastCost
                ? [
                    _c("td", [
                      _vm._v(
                        _vm._s(
                          _vm.formatDateTime(
                            _vm.correctionCosts.lastCost.startTime
                          )
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        _vm._s(
                          _vm.formatDateTime(
                            _vm.correctionCosts.lastCost.endTime
                          )
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(_vm._s(_vm.correctionCosts.lastCost.costCenter))
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(_vm._s(_vm.correctionCosts.lastCost.costUnit))
                    ])
                  ]
                : [
                    _c("td"),
                    _vm._v(" "),
                    _c("td"),
                    _vm._v(" "),
                    _c("td"),
                    _vm._v(" "),
                    _c("td")
                  ]
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c("tr", [
        _c("td", { attrs: { colspan: "1" } }, [
          _vm._v(
            "\n        " + _vm._s(_vm.$t("cellCostCorrection")) + "\n      "
          )
        ]),
        _vm._v(" "),
        _c("td", { attrs: { colspan: "6" } }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col" }, [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$t("generalMinutes")) +
                  "\n            "
              ),
              _c("div", { staticClass: "input-group" }, [
                _c("div", { staticClass: "input-group-prepend" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-secondary",
                      on: {
                        click: function($event) {
                          _vm.costCorrectionMinutesInputFloat -= 1
                        }
                      }
                    },
                    [_c("i", { staticClass: "fa fa-minus" })]
                  )
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.costCorrectionMinutesInputString,
                      expression: "costCorrectionMinutesInputString"
                    }
                  ],
                  staticClass: "form-control",
                  staticStyle: { "max-width": "7em" },
                  domProps: { value: _vm.costCorrectionMinutesInputString },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) return
                      _vm.costCorrectionMinutesInputString = $event.target.value
                    }
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "input-group-append" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-secondary",
                      on: {
                        click: function($event) {
                          _vm.costCorrectionMinutesInputFloat += 1
                        }
                      }
                    },
                    [_c("i", { staticClass: "fa fa-plus" })]
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col" }, [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$t("cellCostCost")) +
                  "\n            "
              ),
              _c("div", { staticClass: "input-group" }, [
                _c("div", { staticClass: "input-group-prepend" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-secondary",
                      on: {
                        click: function($event) {
                          _vm.costCorrectionCostInputFloat -= 1
                        }
                      }
                    },
                    [_c("i", { staticClass: "fa fa-minus" })]
                  )
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.costCorrectionCostInputString,
                      expression: "costCorrectionCostInputString"
                    }
                  ],
                  staticClass: "form-control",
                  staticStyle: { "max-width": "7em" },
                  domProps: { value: _vm.costCorrectionCostInputString },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) return
                      _vm.costCorrectionCostInputString = $event.target.value
                    }
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "input-group-append" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-secondary",
                      on: {
                        click: function($event) {
                          _vm.costCorrectionCostInputFloat += 1
                        }
                      }
                    },
                    [_c("i", { staticClass: "fa fa-plus" })]
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col" }, [
              _vm._v("\n             \n            "),
              _c("div", [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    on: { click: _vm.addCostCorrection }
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("btnAdd")) +
                        "\n              "
                    )
                  ]
                )
              ])
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }